import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from 'react';
import { TAGLink, TAGTypography, TAGDialogContent, TAGDialog, TAGDialogActions, TAGDialogTitle, TAGButton } from '../..';
import RichText from './RichText';

var TermsAndConditions = function TermsAndConditions(_ref) {
  var branding = _ref.branding,
      content = _ref.content,
      headlineText = _ref.headlineText,
      _ref$isDark = _ref.isDark,
      isDark = _ref$isDark === void 0 ? false : _ref$isDark,
      _ref$showTcTextAs = _ref.showTcTextAs,
      showTcTextAs = _ref$showTcTextAs === void 0 ? 'Link' : _ref$showTcTextAs,
      tcLink = _ref.tcLink,
      tcText = _ref.tcText;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleLinkClick = function handleLinkClick(e) {
    e.preventDefault();
    setOpen(!open);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  if (!tcText) {
    return null;
  }

  return React.createElement(React.Fragment, null, showTcTextAs === 'Link' ? React.createElement(TAGLink, {
    href: tcLink,
    onClick: tcLink ? undefined : handleLinkClick,
    underline: "always",
    color: isDark ? 'text.light' : 'text.secondary',
    variant: "lowestLevel"
  }, tcText) : React.createElement(TAGTypography, {
    color: isDark ? 'text.light' : 'text.secondary',
    variant: "lowestLevel"
  }, tcText), React.createElement(TAGDialog, {
    handleClose: handleClose,
    open: open,
    sx: {
      '.MuiPaper-root p': {
        padding: '0 10px'
      }
    }
  }, React.createElement(TAGDialogTitle, null, headlineText), React.createElement(TAGDialogContent, null, React.createElement(RichText, {
    branding: branding,
    contained: true,
    centerAlign: true,
    fullWidth: false,
    content: content
  })), React.createElement(TAGDialogActions, null, React.createElement(TAGButton, {
    onClick: handleClose
  }, "Close"))));
};

export default TermsAndConditions;